(() => {
  const headers = [];
  const headerObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const elem = entry.target;

      elem.querySelector('.swinger-header__wrapper').classList[entry.isIntersecting ? 'add' : 'remove']('swinger-header__wrapper--is-scrolled-top');
    });
  }, {
    threshold: 0.001,
  });

  let lastScrollTop = 0;
  let lastScrollDirection;
  let scrollDirection = document.scrollingElement && document.scrollingElement.scrollTop ? 1 : 0;
  let scrollTimer;

  window.addEventListener('scroll', () => { // or window.addEventListener("scroll"....
    window.clearTimeout(scrollTimer);
    scrollTimer = window.setTimeout(() => { scrollDirection = 0; }, 120);
    const scrollTop = document.scrollingElement && document.scrollingElement.scrollTop;

    switch (true) {
      default:
        break;

      case scrollTop > lastScrollTop:
        // downscroll code
        scrollDirection = 1;
        break;

      case scrollTop < (lastScrollTop - 5):
      case scrollTop < 100:
        // upscroll code
        scrollDirection = -1;
        break;
    }
    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
  }, false);

  const setAppropriateClass = () => {
    if (scrollDirection !== lastScrollDirection) {
      switch (scrollDirection) {
        default:
          break;

        case 1:
          headers.forEach((elem) => elem.classList.add('swinger-header__wrapper--is-retracted'));
          break;

        case -1:
          headers.forEach((elem) => elem.classList.remove('swinger-header__wrapper--is-retracted'));
          break;
      }
      lastScrollDirection = scrollDirection;
    }

    window.requestAnimationFrame(setAppropriateClass);
  };

  window.requestAnimationFrame(setAppropriateClass);

  window.swinger.observer.initialize('.swinger-header .swinger-header__wrapper', (elem) => {
    const parent = elem.closest('.swinger-header');

    headers.push(elem);
    headerObserver.observe(parent);
  }, false);

  /* ------------------------------- */

  try {
    document.querySelector(':focus-within');
  } catch (e) {
    document.addEventListener('click', (e) => {
      const target = window.swinger.eventHub.getTarget(e).closest('a');

      if (!target || !target.matches || !target.matches('a[href="#login"]')) {
        return;
      }

      window.location.href = window.swinger.config.pages.login;
      e.preventDefault();
    }, true);
  }
})();
